var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25,2.25A2.25,2.25,0,0,0,0,4.5,2.22,2.22,0,0,0,2.25,6.75,2.25,2.25,0,0,0,4.5,4.5,2.28,2.28,0,0,0,2.25,2.25Zm0,7.5A2.25,2.25,0,0,0,0,12a2.22,2.22,0,0,0,2.25,2.25A2.25,2.25,0,0,0,4.5,12,2.28,2.28,0,0,0,2.25,9.75Zm0,7.5A2.25,2.25,0,0,0,0,19.5a2.22,2.22,0,0,0,2.25,2.25A2.25,2.25,0,0,0,4.5,19.5,2.28,2.28,0,0,0,2.25,17.25Zm21,.75h-15a.78.78,0,0,0-.75.75v1.5a.74.74,0,0,0,.75.75h15a.78.78,0,0,0,.75-.75v-1.5A.81.81,0,0,0,23.25,18Zm0-15h-15a.78.78,0,0,0-.75.75v1.5A.74.74,0,0,0,8.25,6h15A.78.78,0,0,0,24,5.25V3.75A.81.81,0,0,0,23.25,3Zm0,7.5h-15a.78.78,0,0,0-.75.75v1.5a.74.74,0,0,0,.75.75h15a.78.78,0,0,0,.75-.75v-1.5A.81.81,0,0,0,23.25,10.5Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.9cc0336c.svg";
export { ForwardRef as ReactComponent };